import Axios from "axios";
// import moment from "moment";

const state = () => ({
  menus: [],
  menuDetail: null,
  sidebarMenu: [],
  info: null,
  code: null,
  message: null,
  status: null,
  loading: false,
  host: process.env.VUE_APP_API_HOST || 'http://localhost:8020',
});

const mutations = {
  set_menus(state, menus){
    state.menus = menus
  },
  set_menu_detail(state, menuDetail){
    state.menuDetail = menuDetail
  },
  set_sidebar_menu(state, sidebarMenu){
    state.sidebarMenu = sidebarMenu
  },
  set_info(state, info){
    state.info = info
  },
  set_code(state, code){
    state.code = code
  },
  set_message(state, message){
    state.message = message
  },
  set_status(state, status){
    state.status = status
  },
  set_loading(state, loading){
    state.loading = loading
  }
};

const actions = {
  async fetchMenus({ commit, state }, payload) {
    commit('set_loading', true);

    const url = state.host+"/api/menu";
    const headers = { Authorization: "Bearer " + payload.token, 'Content-Type': 'application/json' };

    try {
      const response = await Axios.get(url, { headers: headers });

      commit('set_menus', response.data.data);
      commit('set_info', response.data.info);
      commit('set_code', response.data.code);
      commit('set_message', response.data.message);
      commit('set_status', response.status);
    } catch (error) {
      commit('set_code', error.response ? error.response.data.code : null);
      commit('set_message', error.response ? error.response.data.message : error.message);
      commit('set_status', error.response ? error.response.status : null);
    } finally {
      commit('set_loading', false);
    }
  },
  async fetchMenuById({ commit, state }, payload) {
    commit('set_loading', true);

    const url = state.host+"/api/menu/"+payload.id;
    const headers = { Authorization: "Bearer " + payload.token, 'Content-Type': 'application/json' };

    try {
      const response = await Axios.get(url, { headers: headers });

      commit('set_menu_detail', response.data.data);
      commit('set_info', response.data.info);
      commit('set_code', response.data.code);
      commit('set_message', response.data.message);
      commit('set_status', response.status);
      
      return response.data.data; // Return data untuk digunakan di component
    } catch (error) {
      commit('set_code', error.response ? error.response.data.code : null);
      commit('set_message', error.response ? error.response.data.message : error.message);
      commit('set_status', error.response ? error.response.status : null);
      throw error; // Throw error untuk di-handle di component
    } finally {
      commit('set_loading', false);
    }
  },
  async fetchMenuOnChildWeb({ commit, state }, payload) {
    commit('set_loading', true);

    const url = state.host+"/api/menu??category=WEB&child=ON";
    const headers = { Authorization: "Bearer " + payload.token, 'Content-Type': 'application/json' };

    try {
      const response = await Axios.get(url, { headers: headers });

      commit('set_menus', response.data.data);
      commit('set_info', response.data.info);
      commit('set_code', response.data.code);
      commit('set_message', response.data.message);
      commit('set_status', response.status);
    } catch (error) {
      commit('set_code', error.response ? error.response.data.code : null);
      commit('set_message', error.response ? error.response.data.message : error.message);
      commit('set_status', error.response ? error.response.status : null);
    } finally {
      commit('set_loading', false);
    }
  },
  async fetchMenuByWeb({ commit, state }, payload) {
    commit('set_loading', true);

    const url = state.host+"/api/roles/menu?roleName="+payload.roleName+"&category=WEB";
    const headers = { Authorization: "Bearer " + payload.token, 'Content-Type': 'application/json' };

    try {
      const response = await Axios.get(url, { headers: headers });

      commit('set_sidebar_menu', response.data.data);
      commit('set_info', response.data.info);
      commit('set_code', response.data.code);
      commit('set_message', response.data.message);
      commit('set_status', response.status);
    } catch (error) {
      commit('set_code', error.response ? error.response.data.code : null);
      commit('set_message', error.response ? error.response.data.message : error.message);
      commit('set_status', error.response ? error.response.status : null);
    } finally {
      commit('set_loading', false);
    }
  },
  async createMenu({ commit, state }, payload) {
    commit('set_loading', true);

    const url = state.host+"/api/menu";
    const headers = { Authorization: "Bearer " + payload.token };

    try {
      const response = await Axios.post(url, payload.form_data, { headers: headers });

      commit('set_menus', response.data.data);
      commit('set_info', response.data.info);
      commit('set_code', response.data.code);
      commit('set_message', response.data.message);
      commit('set_status', response.status);
    } catch (error) {
      commit('set_code', error.response ? error.response.data.code : null);
      commit('set_message', error.response ? error.response.data.message : error.message);
      commit('set_status', error.response ? error.response.status : null);
    } finally {
      commit('set_loading', false);
    }
  },
  async updateMenu({ commit, state }, payload) {
    commit('set_loading', true);

    const url = state.host+`/api/menu/${payload.id}`;
    const headers = { Authorization: "Bearer " + payload.token };

    try {
      const response = await Axios.put(url, payload.form_data, { headers: headers });

      commit('set_menus', response.data.data);
      commit('set_info', response.data.info);
      commit('set_code', response.data.code);
      commit('set_message', response.data.message);
      commit('set_status', response.status);
    } catch (error) {
      commit('set_code', error.response ? error.response.data.code : null);
      commit('set_message', error.response ? error.response.data.message : error.message);
      commit('set_status', error.response ? error.response.status : null);
    } finally {
      commit('set_loading', false);
    }
  },
  async deleteMenu({ commit, state }, payload) {
    commit('set_loading', true);

    const url = state.host+`/api/menu/${payload.id}`;
    const headers = { Authorization: "Bearer " + payload.token };

    try {
      const response = await Axios.delete(url, { headers: headers });

      commit('set_menus', response.data.data);
      commit('set_info', response.data.info);
      commit('set_code', response.data.code);
      commit('set_message', response.data.message);
      commit('set_status', response.status);
    } catch (error) {
      commit('set_code', error.response ? error.response.data.code : null);
      commit('set_message', error.response ? error.response.data.message : error.message);
      commit('set_status', error.response ? error.response.status : null);
    } finally {
      commit('set_loading', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};